// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--hzOMY";
export var formContainer = "styles-module--formContainer--NgO+K";
export var input = "styles-module--input--jnB5g";